import React from 'react';

import { Grid } from '@mui/material';

import { operations } from '@luxuryescapes/contract-svc-promo';

import BorderedGridItem from '~/components/Common/BorderedGridItem';

import { PromoMeta, sortPromoItemByCategoryAndId } from '~/services/PromoService';

import { PromoResponseItem } from './PromoResponseItem';

type PromoOrderTableCellProps = {
  response: operations['calculateDiscount']['responses']['200']['content']['application/json'];
  meta: PromoMeta;
  isDev: boolean;
};

function PromoResponse({ response, meta, isDev }: PromoOrderTableCellProps) {
  if (!response || !response.result || !response.result.promo) {
    return null;
  }

  const { promo } = response.result;

  const { items } = promo;

  return (
    <Grid container>
      {items.sort(sortPromoItemByCategoryAndId).map((item, i) => (
        <BorderedGridItem key={`${item.offerId || item.itemId}_${i}`}>
          <PromoResponseItem
            key={`${item.offerId || item.itemId}_${i}`}
            item={item}
            currencyCode={promo.currency}
            meta={meta}
          />
        </BorderedGridItem>
      ))}
    </Grid>
  );
}

export { PromoResponse };
